export const VALID_IMG_TYPES: string[] = ['image/jpeg', 'image/png', 'image/jpg'];

const ONE_MB_TO_KB = 1024;
export const ONE_MB_TO_BYTES = 1024 * ONE_MB_TO_KB;
export const BYTES_IN_KB = 1024;
export const BYTES_IN_MB = BYTES_IN_KB * 1024;
export const BYTES_IN_GB = BYTES_IN_MB * 1024;
export const DEFAULT_MAX_FILE_SIZE = 500 * ONE_MB_TO_KB;

export const MAX_LIMIT_PHOTO_SIZE = 15000000;
